import { PageTitle, TabChild, Tabs } from "@wit/mpesa-ui-components";
import { Breadcrumb } from "@wit/mpesa-ui-components/lib/types";
import { TFunction } from "i18next";
import React, { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import styled, { ThemeContext } from "styled-components";
import { ConfigContext } from "../../../app.component";
import { RoutesEnum } from "../../../routes/routes.constants";
import { FEATURES } from "../../../shared/renderer.utils";
import { PageContainer } from "../../../shared/shared.styled";
import TriggerJob from "./components/trigger-jobs.tab";

/**
 * Breadcrumbs
 * @param t
 * @returns
 */
const getBreadcrumbs = (t: TFunction): Breadcrumb[] => {
  return [
    {
      label: t("pages.tools.title"),
      url: RoutesEnum.TOOLS,
    },
    {
      label: t("pages.tools.jobsList.title"),
      url: "",
    },
  ];
};

/**
 * Request Jobs list Page
 * @returns
 */
const JobsList = () => {
  const [t] = useTranslation();
  const history = useHistory();
  const themeContext = useContext(ThemeContext);
  const { config } = useContext(ConfigContext);
  const [selectedTabs, setSelectedTabs] = React.useState<ReactElement[]>([]);

  /**
   * Function to render the tabs
   */
  const tabsToRender = () => {
    const tabs = [] as ReactElement[];
    const features = [
      {
        feature: FEATURES.JOBS_LIST,
        label: t("pages.tools.jobsList.title"),
        component: <TriggerJob />,
      },
    ];

    if (config) {
      features.forEach(elem => {
        if (
          !config.disabledFeatures ||
          (config.disabledFeatures !== undefined && !config.disabledFeatures.includes(elem.feature))
        ) {
          tabs.push(
            <TabChild label={elem.label} key={elem.label}>
              {elem.component}
            </TabChild>,
          );
        }
      });
    }

    setSelectedTabs(tabs);
  };

  React.useEffect(() => {
    tabsToRender();
  }, []);

  return (
    <PageContainer>
      <PageTitle
        breadcrumbs={getBreadcrumbs(t)}
        title={t("pages.tools.jobsList.title")}
        navigateFunction={history.push}
        goBackFn={() => window.history.back()}
        separatorStyle={{ display: "none" }}
        titleContainerStyle={{ marginTop: "13px", marginBottom: "34px" }}
        iconContainerStyle={{ stroke: themeContext.palette.vodafoneRed }}
      />
      {selectedTabs.length > 1 ? ( // INFO: In cases where more tabs need to be added this will handle it
        <Tabs>{selectedTabs}</Tabs>
      ) : selectedTabs.length === 1 ? (
        <>{selectedTabs[0]}</>
      ) : (
        <TabsDisabledText>{t("pages.tools.requestPayment.allTabsDisable")}</TabsDisabledText>
      )}
    </PageContainer>
  );
};

export default JobsList;

export const TabsDisabledText = styled("span")`
  font-family: Vodafone Rg;
  color: #333333;
  font-size: 16px;
  padding: 20px 0px 20px 0px;
`;
